import { render } from "./ScorecardView.vue?vue&type=template&id=52b12fec&scoped=true&ts=true"
import script from "./ScorecardView.vue?vue&type=script&lang=ts"
export * from "./ScorecardView.vue?vue&type=script&lang=ts"

import "./ScorecardView.vue?vue&type=style&index=0&id=52b12fec&scoped=true&lang=css"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b12fec"]])

export default __exports__